import { PERMISSIONS } from '@/constants/permissions'
import { ROUTES } from '@/constants/routesConstants'

export interface OptionalRoute {
  path: string
  componentName: string
  status?: number
  privateRouter: boolean
  isMenu?: boolean
  children?: OptionalRoute[]
  permissions: string[]
}
export const routes: OptionalRoute[] = [
  // {
  //   path: ROUTES.LOGIN,
  //   componentName: 'login/index',
  //   privateRouter: true,
  //   isMenu: false
  // },
  {
    path: ROUTES.TRANG_CHU,
    componentName: 'home-page/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.TRANGCHU]
  },
  {
    path: '',
    componentName: 'home-page/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.TRANGCHU]
  },
  // Quản trị hệ thống
  {
    path: ROUTES.DON_VI_THEO_DOI,
    componentName: 'system-management/tracking-unit/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  // Nhóm đối tượng thanh tra
  {
    path: ROUTES.NHOM_DOI_TUONG_THANH_TRA,
    componentName: 'system-management/nhom-doi-tuong-thanh-tra/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.DM_NHOMDOITUONG_DANHSACH]
  },
  // Đối tượng thanh tra
  {
    path: ROUTES.DOI_TUONG_THANH_TRA,
    componentName: 'system-management/doi-tuong-thanh-tra/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.DM_DOITUONGTHANHTRA_DANHSACH]
  },
  // Loại lĩnh vực vi phạm
  {
    path: ROUTES.DANH_MUC_LOAI_LINH_VUC_VI_PHAM,
    componentName: 'system-management/loai-linh-vuc-vi-pham/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  // Loại nguồn vốn
  {
    path: ROUTES.DANH_MUC_LOAI_NGUON_VON,
    componentName: 'system-management/loai-nguon-von/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.DM_LOAINGUONVON_DANHSACH]
  },
  // Loại kết luận
  {
    path: ROUTES.DANH_MUC_LOAI_KET_LUAN,
    componentName: 'system-management/loai-ket-luan/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.DM_LOAIKETLUAN_DANHSACH]
  },
  // Loại chi phí
  {
    path: ROUTES.DANH_MUC_LOAI_CHI_PHI,
    componentName: 'system-management/loai-chi-phi/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.DM_LOAICHIPHI_DANHSACH]
  },
  // Loại Kiểm toán
  {
    path: ROUTES.DANH_MUC_LOAI_KIEM_TOAN,
    componentName: 'system-management/loai-kiem-toan/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.DM_LOAIKIEMTOAN_DANHSACH]
  },
  // Hình thức xử lý
  {
    path: ROUTES.DANH_MUC_HINH_THUC_XU_LY,
    componentName: 'system-management/danh-muc-hinh-thuc-xu-ly/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.DM_HINHTHUCXULY_DANHSACH]
  },
  // Hình thức xử lý
  {
    path: ROUTES.DANH_MUC_HINH_THUC_KIEN_NGHI,
    componentName: 'system-management/danh-muc-hinh-thuc-kien-nghi/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.DM_HINHTHUCKIENNGHI_DANHSACH]
  },
  // Dự án
  {
    path: ROUTES.DANH_MUC_DU_AN,
    componentName: 'system-management/loai-du-an/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.DM_DUAN_DANHSACH]
  },
  {
    path: ROUTES.HOAT_DONG_THANH_TRA,
    componentName: 'system-management/inspection-activities/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  {
    path: ROUTES.KIEN_NGHI_TAI_CHINH,
    componentName: 'system-management/financial-proposal/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  {
    path: ROUTES.BAO_CAO_KIEM_TOAN,
    componentName: 'system-management/audit-report/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  {
    path: ROUTES.NHOM_NGUOI_DUNG,
    componentName: 'system-management/user-group/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  {
    path: ROUTES.QUAN_LY_NGUOI_DUNG,
    componentName: 'system-management/user-management/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  {
    path: `${ROUTES.QUAN_LY_NGUOI_DUNG}${ROUTES.THEM_MOI}`,
    componentName: 'system-management/user-management/add-user/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  {
    path: `${ROUTES.QUAN_LY_NGUOI_DUNG}${ROUTES.ID}${ROUTES.CHINH_SUA}`,
    componentName: 'system-management/user-management/add-user/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  {
    path: `${ROUTES.DANH_MUC_DON_VI}${ROUTES.PARENT_ID}`,
    componentName: 'system-management/units/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  {
    path: `${ROUTES.DANH_MUC_DON_VI}${ROUTES.PARENT_ID}${ROUTES.THEM_MOI}`,
    componentName: 'system-management/units/add-unit/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  {
    path: `${ROUTES.DANH_MUC_DON_VI}${ROUTES.PARENT_ID}${ROUTES.CHINH_SUA}${ROUTES.ID}`,
    componentName: 'system-management/units/add-unit/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  {
    path: `${ROUTES.DANH_MUC_PHONG_BAN}${ROUTES.PARENT_ID}`,
    componentName: 'system-management/departments/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  {
    path: `${ROUTES.DANH_MUC_PHONG_BAN}${ROUTES.PARENT_ID}${ROUTES.THEM_MOI}`,
    componentName: 'system-management/departments/add-department/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  {
    path: `${ROUTES.DANH_MUC_PHONG_BAN}${ROUTES.PARENT_ID}${ROUTES.CHINH_SUA}${ROUTES.ID}`,
    componentName: 'system-management/departments/add-department/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  {
    path: ROUTES.DANH_MUC_CHUC_VU,
    componentName: 'system-management/titles/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  {
    path: `${ROUTES.DANH_MUC_CHUC_VU}${ROUTES.THEM_MOI}`,
    componentName: 'system-management/titles/add-title/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  {
    path: `${ROUTES.DANH_MUC_CHUC_VU}${ROUTES.ID}${ROUTES.CHINH_SUA}`,
    componentName: 'system-management/titles/add-title/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  {
    path: ROUTES.DANH_MUC_VAI_TRO,
    componentName: 'system-management/roles/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  {
    path: `${ROUTES.DANH_MUC_VAI_TRO}${ROUTES.THEM_MOI}`,
    componentName: 'system-management/roles/add-role/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  {
    path: `${ROUTES.DANH_MUC_VAI_TRO}${ROUTES.ID}${ROUTES.CHINH_SUA}`,
    componentName: 'system-management/roles/add-role/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  {
    path: ROUTES.PHAN_QUYEN_VAI_TRO,
    componentName: 'system-management/role-delegation/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  // {
  //   path: ROUTES.QUAN_LY_UNG_DUNG,
  //   componentName: 'system-management/app-management/index',
  //   privateRouter: false,
  //   isMenu: true
  // },
  // {
  //   path: `${ROUTES.QUAN_LY_UNG_DUNG}${ROUTES.THEM_MOI}`,
  //   componentName: 'system-management/app-management/add-app/index',
  //   privateRouter: false,
  //   isMenu: true
  // },
  // {
  //   path: `${ROUTES.QUAN_LY_UNG_DUNG}${ROUTES.ID}${ROUTES.CHINH_SUA}`,
  //   componentName: 'system-management/app-management/add-app/index',
  //   privateRouter: false,
  //   isMenu: true
  // },
  {
    path: ROUTES.SAO_LUU_DU_LIEU,
    componentName: 'system-management/backup-data/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.SAOLUUBACKUP_XEM]
  },
  {
    path: ROUTES.DANH_SACH_THONG_BAO,
    componentName: 'system-management/danh-sach-thong-bao/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  {
    path: `${ROUTES.DANH_SACH_THONG_BAO}/:id`,
    componentName: 'system-management/danh-sach-thong-bao/detail/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  // Kết luận thanh tra
  {
    path: `${ROUTES.DANH_SACH_KET_LUAN_THANH_TRA}`,
    componentName: 'ket-luan-thanh-tra/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.QLKLKNTHANHTRA_DANHSACH]
  },
  // Kết luận thanh tra
  {
    path: `${ROUTES.QL_DANH_SACH_KET_LUAN_THANH_TRA}`,
    componentName: 'ket-luan-thanh-tra/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KETLUANTHANHTRA_XEMTATCA]
  },
  // Thêm mới kết luận
  {
    path: `${ROUTES.DANH_SACH_KET_LUAN_THANH_TRA}/create`,
    componentName: 'ket-luan-thanh-tra/create/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.QLKLKNTHANHTRA_CAPNHAT]
  },
  // Chỉnh sửa kết luận
  {
    path: `${ROUTES.DANH_SACH_KET_LUAN_THANH_TRA}/:id`,
    componentName: 'ket-luan-thanh-tra/create/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.QLKLKNTHANHTRA_CAPNHAT]
  },
  // Chi tiết kết luận
  {
    path: `${ROUTES.DANH_SACH_KET_LUAN_THANH_TRA}/detail/:id`,
    componentName: 'ket-luan-thanh-tra/detail/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.QLKLKNTHANHTRA_DANHSACH]
  },
  // Chi tiết kết luận theo dõi
  {
    path: `${ROUTES.QL_DANH_SACH_KET_LUAN_THANH_TRA}/detail/:id`,
    componentName: 'ket-luan-thanh-tra/detail/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KETLUANTHANHTRA_XEMTATCA]
  },
  // Thêm mới kiến nghị
  {
    path: `${ROUTES.DANH_SACH_KET_LUAN_THANH_TRA}/:ketLuanId/:id`,
    componentName: 'ket-luan-thanh-tra/kien-nghi/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.QLKLKNTHANHTRA_CAPNHAT]
  },
  // Chỉnh sửa kiến nghị
  {
    path: `${ROUTES.DANH_SACH_KET_LUAN_THANH_TRA}/:ketLuanId/:id/:kienNghiId`,
    componentName: 'ket-luan-thanh-tra/kien-nghi/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.QLKLKNTHANHTRA_CAPNHAT]
  },
  // Chỉ tiết kiến nghị
  {
    path: `${ROUTES.DANH_SACH_KET_LUAN_THANH_TRA}/:ketLuanId/:id/detail/:kienNghiId`,
    componentName: 'ket-luan-thanh-tra/kien-nghi/detail-kien-nghi/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.QLKLKNTHANHTRA_DANHSACH]
  },
  // Chỉ tiết kiến nghị QL_DANH_SACH_KET_LUAN_THANH_TRA
  {
    path: `${ROUTES.QL_DANH_SACH_KET_LUAN_THANH_TRA}/:ketLuanId/:id/detail/:kienNghiId`,
    componentName: 'ket-luan-thanh-tra/kien-nghi/detail-kien-nghi/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KETLUANTHANHTRA_XEMTATCA]
  },

  // Danh sách kiến nghị
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI}`,
    componentName: 'kien-nghi-thanh-tra/danh-sach-kien-nghi/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_THANHTRA_XEM]
  },

  // Danh sách theo dõi kiến nghị
  {
    path: `${ROUTES.THEO_DOI_KIEN_NGHI_THANH_TRA}`,
    componentName: 'kien-nghi-thanh-tra/danh-sach-kien-nghi/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THEODOIKIENNGHI_THANHTRA]
  },

  // Quản lý theo dõi kiến nghị thanh tra
  {
    path: `${ROUTES.QL_DANH_SACH_KIEN_NGHI_THANH_TRA}`,
    componentName: 'kien-nghi-thanh-tra/danh-sach-kien-nghi/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KIENNGHITHANHTRA_XEMTATCA]
  },

  // Chi tiết kiến nghị thu hồi nsnn
  {
    path: `${ROUTES.THEO_DOI_KIEN_NGHI_THANH_TRA}/detail/THU_HOI_VE_NSNN/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/thu-hoi-nsnn/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THEODOIKIENNGHI_THANHTRA]
  },
  // Chi tiết kiến nghị xử lý kinh tế
  {
    path: `${ROUTES.THEO_DOI_KIEN_NGHI_THANH_TRA}/detail/XU_LY_VE_KINH_TE/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/kien-nghi-xu-ly-kinh-te/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THEODOIKIENNGHI_THANHTRA]
  },
  // Chi tiết kiến nghị xử lý về hành chính
  {
    path: `${ROUTES.THEO_DOI_KIEN_NGHI_THANH_TRA}/detail/XU_LY_VE_HANH_CHINH/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/kien-nghi-xu-ly-ve-hanh-chinh/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THEODOIKIENNGHI_THANHTRA]
  },
  // Chi tiết kiến nghị kiến nghị xử lý khác
  {
    path: `${ROUTES.THEO_DOI_KIEN_NGHI_THANH_TRA}/detail/XU_LY_KHAC/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/kien-nghi-xu-ly-khac/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THEODOIKIENNGHI_THANHTRA]
  },
  // Chi tiết kiến nghị kiến nghị xử lý chuyển CQDT
  {
    path: `${ROUTES.THEO_DOI_KIEN_NGHI_THANH_TRA}/detail/XU_LY_CHUYEN_CQDT/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/kien-nghi-xu-ly-chuyen-CQDT/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THEODOIKIENNGHI_THANHTRA]
  },
  // Chi tiết kiến nghị kiến nghị xử lý HOAN_THIEN_CO_CHE_CHINH_SACH
  {
    path: `${ROUTES.THEO_DOI_KIEN_NGHI_THANH_TRA}/detail/HOAN_THIEN_CO_CHE_CHINH_SACH/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/kien-nghi-xu-ly-hoan-thien-co-che-chinh-sach/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THEODOIKIENNGHI_THANHTRA]
  },

  // Chi tiết kiến nghị kiến nghị xử lý KIEM_DIEM_TRACH_NHIEM
  {
    path: `${ROUTES.THEO_DOI_KIEN_NGHI_THANH_TRA}/detail/KIEM_DIEM_TRACH_NHIEM/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/kien-nghi-xu-ly-kiem-diem-trach-nhiem/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THEODOIKIENNGHI_THANHTRA]
  },

  // Chi tiết kiến nghị thu hồi nsnn
  {
    path: `${ROUTES.QL_DANH_SACH_KIEN_NGHI_THANH_TRA}/detail/THU_HOI_VE_NSNN/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/thu-hoi-nsnn/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KIENNGHITHANHTRA_XEMTATCA]
  },
  // Chi tiết kiến nghị xử lý kinh tế
  {
    path: `${ROUTES.QL_DANH_SACH_KIEN_NGHI_THANH_TRA}/detail/XU_LY_VE_KINH_TE/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/kien-nghi-xu-ly-kinh-te/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KIENNGHITHANHTRA_XEMTATCA]
  },
  // Chi tiết kiến nghị xử lý về hành chính
  {
    path: `${ROUTES.QL_DANH_SACH_KIEN_NGHI_THANH_TRA}/detail/XU_LY_VE_HANH_CHINH/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/kien-nghi-xu-ly-ve-hanh-chinh/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KIENNGHITHANHTRA_XEMTATCA]
  },
  // Chi tiết kiến nghị kiến nghị xử lý khác
  {
    path: `${ROUTES.QL_DANH_SACH_KIEN_NGHI_THANH_TRA}/detail/XU_LY_KHAC/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/kien-nghi-xu-ly-khac/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KIENNGHITHANHTRA_XEMTATCA]
  },
  // Chi tiết kiến nghị kiến nghị xử lý chuyển CQDT
  {
    path: `${ROUTES.QL_DANH_SACH_KIEN_NGHI_THANH_TRA}/detail/XU_LY_CHUYEN_CQDT/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/kien-nghi-xu-ly-chuyen-CQDT/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KIENNGHITHANHTRA_XEMTATCA]
  },
  // Chi tiết kiến nghị kiến nghị xử lý HOAN_THIEN_CO_CHE_CHINH_SACH
  {
    path: `${ROUTES.QL_DANH_SACH_KIEN_NGHI_THANH_TRA}/detail/HOAN_THIEN_CO_CHE_CHINH_SACH/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/kien-nghi-xu-ly-hoan-thien-co-che-chinh-sach/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KIENNGHITHANHTRA_XEMTATCA]
  },

  // Chi tiết kiến nghị kiến nghị xử lý KIEM_DIEM_TRACH_NHIEM
  {
    path: `${ROUTES.QL_DANH_SACH_KIEN_NGHI_THANH_TRA}/detail/KIEM_DIEM_TRACH_NHIEM/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/kien-nghi-xu-ly-kiem-diem-trach-nhiem/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KIENNGHITHANHTRA_XEMTATCA]
  },

  // Chỉnh sửa kiến nghị thu hồi nsnn
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI}/edit/THU_HOI_VE_NSNN/:id`,
    componentName: 'kien-nghi-thanh-tra/chinh-sua-kien-nghi/thu-hoi-nsnn/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_THANHTRA_CAPNHAT]
  },
  // Chỉnh sửa kiến nghị kiến nghị xử lý kinh tế
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI}/edit/XU_LY_VE_KINH_TE/:id`,
    componentName: 'kien-nghi-thanh-tra/chinh-sua-kien-nghi/kien-nghi-xu-ly-kinh-te/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_THANHTRA_CAPNHAT]
  },
  // Chỉnh sửa kiến nghị kiến nghị xử lý hành chính
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI}/edit/XU_LY_VE_HANH_CHINH/:id`,
    componentName: 'kien-nghi-thanh-tra/chinh-sua-kien-nghi/kien-nghi-xu-ly-ve-hanh-chinh/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_THANHTRA_CAPNHAT]
  },
  // Chỉnh sửa kiến nghị kiến nghị xử lý khác
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI}/edit/XU_LY_KHAC/:id`,
    componentName: 'kien-nghi-thanh-tra/chinh-sua-kien-nghi/kien-nghi-xu-ly-khac/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_THANHTRA_CAPNHAT]
  },
  // Chỉnh sửa kiến nghị kiến nghị xử lý chuyển CQDT
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI}/edit/XU_LY_CHUYEN_CQDT/:id`,
    componentName: 'kien-nghi-thanh-tra/chinh-sua-kien-nghi/kien-nghi-xu-ly-chuyen-CQDT/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_THANHTRA_CAPNHAT]
  },
  // Chỉnh sửa kiến nghị kiến nghị xử lý HOAN_THIEN_CO_CHE_CHINH_SACH
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI}/edit/HOAN_THIEN_CO_CHE_CHINH_SACH/:id`,
    componentName: 'kien-nghi-thanh-tra/chinh-sua-kien-nghi/kien-nghi-xu-ly-hoan-thien-co-che-chinh-sach/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_THANHTRA_CAPNHAT]
  },
  // Chỉnh sửa kiến nghị kiến nghị xử lý KIEM_DIEM_TRACH_NHIEM
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI}/edit/KIEM_DIEM_TRACH_NHIEM/:id`,
    componentName: 'kien-nghi-thanh-tra/chinh-sua-kien-nghi/kien-nghi-xu-ly-kiem-diem-trach-nhiem/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_THANHTRA_CAPNHAT]
  },
  // Chi tiết kiến nghị thu hồi nsnn
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI}/detail/THU_HOI_VE_NSNN/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/thu-hoi-nsnn/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_THANHTRA_XEM]
  },
  // Chi tiết kiến nghị xử lý kinh tế
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI}/detail/XU_LY_VE_KINH_TE/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/kien-nghi-xu-ly-kinh-te/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_THANHTRA_XEM]
  },
  // Chi tiết kiến nghị xử lý về hành chính
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI}/detail/XU_LY_VE_HANH_CHINH/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/kien-nghi-xu-ly-ve-hanh-chinh/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_THANHTRA_XEM]
  },
  // Chi tiết kiến nghị kiến nghị xử lý khác
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI}/detail/XU_LY_KHAC/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/kien-nghi-xu-ly-khac/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_THANHTRA_XEM]
  },
  // Chi tiết kiến nghị kiến nghị xử lý chuyển CQDT
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI}/detail/XU_LY_CHUYEN_CQDT/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/kien-nghi-xu-ly-chuyen-CQDT/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_THANHTRA_XEM]
  },
  // Chi tiết kiến nghị KIEM_DIEM_TRACH_NHIEM
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI}/detail/KIEM_DIEM_TRACH_NHIEM/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/kien-nghi-xu-ly-kiem-diem-trach-nhiem/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_THANHTRA_XEM]
  },
  // Chi tiết kiến nghị kiến nghị xử lý HOAN_THIEN_CO_CHE_CHINH_SACH
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI}/detail/HOAN_THIEN_CO_CHE_CHINH_SACH/:id`,
    componentName: 'kien-nghi-thanh-tra/detail-kien-nghi/kien-nghi-xu-ly-hoan-thien-co-che-chinh-sach/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_THANHTRA_XEM]
  },
  // Danh sách kết luận KTNN
  {
    path: `${ROUTES.DANH_SACH_KET_LUAN_KTNN}`,
    componentName: 'ket-luan-KTNN/danh-sach-ket-luan/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.QLKLKNKIEMTOAN_DANHSACH]
  },
  // Thên mới kết luận KTNN
  {
    path: `${ROUTES.DANH_SACH_KET_LUAN_KTNN}/create`,
    componentName: 'ket-luan-KTNN/create/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.QLKLKNKIEMTOAN_CAPNHAT]
  },
  // Chỉnh sửa kết luận KTNN
  {
    path: `${ROUTES.DANH_SACH_KET_LUAN_KTNN}/:id`,
    componentName: 'ket-luan-KTNN/create/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.QLKLKNKIEMTOAN_CAPNHAT]
  },
  // Thêm mới kiến nghị KTNN
  {
    path: `${ROUTES.DANH_SACH_KET_LUAN_KTNN}/:ketLuanId/:id`,
    componentName: 'ket-luan-KTNN/kien-nghi/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.QLKLKNKIEMTOAN_CAPNHAT]
  },
  // Chỉnh sửa kiến nghị KTNN
  {
    path: `${ROUTES.DANH_SACH_KET_LUAN_KTNN}/:ketLuanId/:id/:kienNghiId`,
    componentName: 'ket-luan-KTNN/kien-nghi/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.QLKLKNKIEMTOAN_CAPNHAT]
  },

  // Danh sách thực hiện kiến nghị Kiểm toán
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI_KIEM_TOAN}`,
    componentName: 'kien-nghi-kiem-toan/danh-sach-kien-nghi/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_KIEMTOAN_XEM]
  },
  // Chi tiết Kết luận KTNN
  {
    path: `${ROUTES.DANH_SACH_KET_LUAN_KTNN}/detail/:id`,
    componentName: 'ket-luan-KTNN/detail/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.QLKLKNKIEMTOAN_DANHSACH]
  },
  // Chỉ tiết kiến nghị KTNN
  {
    path: `${ROUTES.DANH_SACH_KET_LUAN_KTNN}/:ketLuanId/:id/detail/:kienNghiId`,
    componentName: 'ket-luan-KTNN/kien-nghi/detail-kien-nghi/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.QLKLKNKIEMTOAN_DANHSACH]
  },
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI_KIEM_TOAN}${ROUTES.CHINH_SUA}${ROUTES.XU_LY_TAI_CHINH}${ROUTES.ID}`,
    componentName: 'kien-nghi-kiem-toan/chinh-sua-kien-nghi/xu-ly-kien-nghi-tai-chinh/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_KIEMTOAN_CAPNHAT]
  },
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI_KIEM_TOAN}${ROUTES.CHI_TIET}${ROUTES.XU_LY_TAI_CHINH}${ROUTES.ID}`,
    componentName: 'kien-nghi-kiem-toan/chi-tiet-kien-nghi/xu-ly-kien-nghi-tai-chinh/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_KIEMTOAN_XEM]
  },
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI_KIEM_TOAN}${ROUTES.CHINH_SUA}${ROUTES.XU_LY_CO_CHE_CHINH_SACH}${ROUTES.ID}`,
    componentName: 'kien-nghi-kiem-toan/chinh-sua-kien-nghi/xu-ly-co-che-chinh-sach/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_KIEMTOAN_CAPNHAT]
  },
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI_KIEM_TOAN}${ROUTES.CHI_TIET}${ROUTES.XU_LY_CO_CHE_CHINH_SACH}${ROUTES.ID}`,
    componentName: 'kien-nghi-kiem-toan/chi-tiet-kien-nghi/xu-ly-co-che-chinh-sach/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_KIEMTOAN_XEM]
  },
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI_KIEM_TOAN}${ROUTES.CHINH_SUA}${ROUTES.XU_LY_KIEM_DIEM_TRACH_NHIEM}${ROUTES.ID}`,
    componentName: 'kien-nghi-kiem-toan/chinh-sua-kien-nghi/xu-ly-kiem-diem-trach-nhiem/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_KIEMTOAN_CAPNHAT]
  },
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI_KIEM_TOAN}${ROUTES.CHINH_SUA}${ROUTES.KTNN_CHAN_CHINH_RUT_KINH_NGHIEM}${ROUTES.ID}`,
    componentName: 'kien-nghi-kiem-toan/chinh-sua-kien-nghi/xu-ly-chan-chinh-rut-kinh-nghiem/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_KIEMTOAN_CAPNHAT]
  },
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI_KIEM_TOAN}${ROUTES.CHI_TIET}${ROUTES.XU_LY_KIEM_DIEM_TRACH_NHIEM}${ROUTES.ID}`,
    componentName: 'kien-nghi-kiem-toan/chi-tiet-kien-nghi/xu-ly-kiem-diem-trach-nhiem/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_KIEMTOAN_XEM]
  },
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI_KIEM_TOAN}${ROUTES.CHI_TIET}${ROUTES.KTNN_CHAN_CHINH_RUT_KINH_NGHIEM}${ROUTES.ID}`,
    componentName: 'kien-nghi-kiem-toan/chi-tiet-kien-nghi/xu-ly-chan-chinh-rut-kinh-nghiem/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_KIEMTOAN_XEM]
  },
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI_KIEM_TOAN}${ROUTES.CHINH_SUA}${ROUTES.XU_LY_KHAC}${ROUTES.ID}`,
    componentName: 'kien-nghi-kiem-toan/chinh-sua-kien-nghi/xu-ly-khac/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_KIEMTOAN_CAPNHAT]
  },
  {
    path: `${ROUTES.DANH_SACH_THUC_HIEN_KIEN_NGHI_KIEM_TOAN}${ROUTES.CHI_TIET}${ROUTES.XU_LY_KHAC}${ROUTES.ID}`,
    componentName: 'kien-nghi-kiem-toan/chi-tiet-kien-nghi/xu-ly-khac/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THUCHIENKIENNGHI_KIEMTOAN_XEM]
  },

  // Theo dõi kết luận Kiểm toán nhà nước
  {
    path: `${ROUTES.QL_DANH_SACH_KET_LUAN_KTNN}`,
    componentName: 'ket-luan-KTNN/danh-sach-ket-luan/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KETLUANKIEMTOAN_XEMTATCA]
  },

  // Chi tiết theo dõi kết luận KTNN
  {
    path: `${ROUTES.QL_DANH_SACH_KET_LUAN_KTNN}/detail/:id`,
    componentName: 'ket-luan-KTNN/detail/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KETLUANKIEMTOAN_XEMTATCA]
  },

  // Chỉ tiết kiến nghị KTNN
  {
    path: `${ROUTES.QL_DANH_SACH_KET_LUAN_KTNN}/:ketLuanId/:id/detail/:kienNghiId`,
    componentName: 'ket-luan-KTNN/kien-nghi/detail-kien-nghi/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KETLUANKIEMTOAN_XEMTATCA]
  },

  // Theo dõi kiến nghị kiểm toán nhà nước
  {
    path: `${ROUTES.THEO_DOI_KIEN_NGHI_KTNN}`,
    componentName: 'kien-nghi-kiem-toan/danh-sach-kien-nghi/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THEODOIKIENNGHI_KIEMTOAN]
  },

  // Chi tiết theo dõi kiến nghị xử lý tài chính
  {
    path: `${ROUTES.THEO_DOI_KIEN_NGHI_KTNN}${ROUTES.CHI_TIET}${ROUTES.XU_LY_TAI_CHINH}${ROUTES.ID}`,
    componentName: 'kien-nghi-kiem-toan/chi-tiet-kien-nghi/xu-ly-kien-nghi-tai-chinh/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THEODOIKIENNGHI_KIEMTOAN]
  },

  // Chi tiết theo dõi kiến nghị xử lý cơ chế chính sách
  {
    path: `${ROUTES.THEO_DOI_KIEN_NGHI_KTNN}${ROUTES.CHI_TIET}${ROUTES.XU_LY_CO_CHE_CHINH_SACH}${ROUTES.ID}`,
    componentName: 'kien-nghi-kiem-toan/chi-tiet-kien-nghi/xu-ly-co-che-chinh-sach/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THEODOIKIENNGHI_KIEMTOAN]
  },

  // Chi tiết theo dõi kiến nghị xử lý kiểm điểm
  {
    path: `${ROUTES.THEO_DOI_KIEN_NGHI_KTNN}${ROUTES.CHI_TIET}${ROUTES.XU_LY_KIEM_DIEM_TRACH_NHIEM}${ROUTES.ID}`,
    componentName: 'kien-nghi-kiem-toan/chi-tiet-kien-nghi/xu-ly-kiem-diem-trach-nhiem/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THEODOIKIENNGHI_KIEMTOAN]
  },

  // Chi tiết theo dõi kiến nghị chấn chỉnh rút kinh nghiệm
  {
    path: `${ROUTES.THEO_DOI_KIEN_NGHI_KTNN}${ROUTES.CHI_TIET}${'/xu-ly-chan-chinh-rut-kinh-nghiem'}${ROUTES.ID}`,
    componentName: 'kien-nghi-kiem-toan/chi-tiet-kien-nghi/xu-ly-chan-chinh-rut-kinh-nghiem/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THEODOIKIENNGHI_KIEMTOAN]
  },

  // Chi tiết theo dõi kiến nghị xử lý khác
  {
    path: `${ROUTES.THEO_DOI_KIEN_NGHI_KTNN}${ROUTES.CHI_TIET}${ROUTES.XU_LY_KHAC}${ROUTES.ID}`,
    componentName: 'kien-nghi-kiem-toan/chi-tiet-kien-nghi/xu-ly-khac/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.THEODOIKIENNGHI_KIEMTOAN]
  },

  // Báo cáo tổng hợp kết quả rà soát các cuộc thanh tra về kinh tế - xã hội
  {
    path: `${ROUTES.BAO_CAO_TONG_HOP_KET_QUA_RA_SOAT_CAC_CUOC_TT_VE_KTXH}`,
    componentName: 'bao-cao-thong-ke/bao-cao-tong-hop-ket-qua-ra-soat-tt-ve-ktxh/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },

  // Báo cáo tổng hợp kết quả thực hiện kiến nghị xử lý sai phạm về kinh tế
  {
    path: `${ROUTES.BAO_CAO_TONG_HOP_KET_QUA_THUC_HIEN_KIEN_NGHI_KTXH}`,
    componentName: 'bao-cao-thong-ke/bao-cao-tong-hop-ket-qua-thuc-hien-kien-nghi-ktxh/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },

  //Báo cáo kết quả thực hiện kiến nghị các nội dung kiến nghị kiểm toán
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_CAC_NOI_DUNG_KIEN_NGHI_KIEM_TOAN}`,
    componentName: 'bao-cao-thong-ke/bao-cao-ket-qua-thuc-hien-cac-noi-dung-knkt/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_CAC_NOI_DUNG_KIEN_NGHI_KIEM_TOAN_CHI_TIET}`,
    componentName: 'bao-cao-thong-ke/bao-cao-ket-qua-thuc-hien-cac-noi-dung-knkt/chi-tiet/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },

  {
    path: `${ROUTES.BAO_CAO_TONG_HOP_KET_LUAN_THANH_TRA_KIEM_TOAN}`,
    componentName: 'bao-cao-thong-ke/bao-cao-tong-hop-ket-luan-thanh-tra-kiem-toan/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },
  {
    path: `${ROUTES.BAO_CAO_TONG_HOP_KET_LUAN_THANH_TRA_KIEM_TOAN_CHI_TIET}`,
    componentName: 'bao-cao-thong-ke/bao-cao-tong-hop-ket-luan-thanh-tra-kiem-toan/chi-tiet/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },
  // Báo cáo kết quả thực hiện kiến nghị xử lý tài chính và xử lý khác
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_KIEN_NGHI_XU_LY_TC_XU_LY_KHAC}`,
    componentName: 'bao-cao-thong-ke/bao-cao-ket-qua-thuc-hien-kien-nghi-xu-ly-tc-xu-ly-khac/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_KIEN_NGHI_XU_LY_TC_XU_LY_KHAC_CHI_TIET}`,
    componentName: 'bao-cao-thong-ke/bao-cao-ket-qua-thuc-hien-kien-nghi-xu-ly-tc-xu-ly-khac/chi-tiet/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },

  // Báo cáo kết quả thực hiện các nội dung kiến nghị thanh tra
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA}`,
    componentName: 'bao-cao-thong-ke/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_CHI_TIET}`,
    componentName: 'bao-cao-thong-ke/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/tong/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_DA_THUC_HIEN}`,
    componentName:
      'bao-cao-thong-ke/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/da-thuc-hien/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_CHUA_THUC_HIEN}`,
    componentName:
      'bao-cao-thong-ke/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/chua-thuc-hien/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_CCCS}`,
    componentName: 'bao-cao-thong-ke/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/cccs/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_CCCS_CHUA_THUC_HIEN}`,
    componentName:
      'bao-cao-thong-ke/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/cccs/chua-thuc-hien/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_CCCS_DA_THUC_HIEN}`,
    componentName:
      'bao-cao-thong-ke/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/cccs/da-thuc-hien/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_HANH_CHINH}`,
    componentName: 'bao-cao-thong-ke/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/hanh-chinh/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_HANH_CHINH_CHUA_THUC_HIEN}`,
    componentName:
      'bao-cao-thong-ke/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/hanh-chinh/chua-thuc-hien/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_HANH_CHINH_DA_THUC_HIEN}`,
    componentName:
      'bao-cao-thong-ke/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/hanh-chinh/da-thuc-hien/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_CCDT}`,
    componentName: 'bao-cao-thong-ke/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/chuyen-cqdt/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_CCDT_CHUA_THUC_HIEN}`,
    componentName:
      'bao-cao-thong-ke/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/chuyen-cqdt/chua-thuc-hien/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_CCDT_DA_THUC_HIEN}`,
    componentName:
      'bao-cao-thong-ke/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/chuyen-cqdt/da-thuc-hien/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_XLK}`,
    componentName: 'bao-cao-thong-ke/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/xu-ly-khac/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_XLK_DA_THUC_HIEN}`,
    componentName:
      'bao-cao-thong-ke/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/xu-ly-khac/da-thuc-hien/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_THUC_HIEN_NOI_DUNG_KIEN_NGHI_THANH_TRA_XLK_CHUA_THUC_HIEN}`,
    componentName:
      'bao-cao-thong-ke/bao-cao-ket-qua-thuc-hien-noi-dung-kien-nghi-thanh-tra/chi-tiet/xu-ly-khac/chua-thuc-hien/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },

  // Xuất Tờ trình - Kết luận Thanh tra Chính phủ (KL 77-KL/TW)
  {
    path: `${ROUTES.XUAT_TO_TRINH_KL77}`,
    componentName: 'bao-cao-thong-ke/xuat-to-trinh-kl77/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },

  // Báo cáo chi tiết theo đơn vị — kết quả thực hiện kiến nghị xử lý sai phạm (tiền / đất); isMenu: bọc AdminLayout (sidebar giống trang tổng hợp)
  {
    path: `${ROUTES.BAO_CAO_CHI_TIET_KET_QUA_THUC_HIEN_KIEN_NGHI_KTXH}`,
    componentName: 'bao-cao-thong-ke/bao-cao-tong-hop-ket-qua-thuc-hien-kien-nghi-ktxh/chi-tiet/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },

  // Báo cáo chi tiết các vụ việc, đối tượng chuyển cơ quan điều tra
  {
    path: `${ROUTES.BAO_CAO_CHI_TIET_CAC_VU_VIEC_DOI_TUONG_CHUYEN_CO_QUAN_DIEU_TRA}`,
    componentName: 'bao-cao-thong-ke/bao-cao-chi-tiet-cac-vu-viec-doi-tuong-chuyen-cqdt/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },

  // Báo cáo chi tiết các vụ việc, đối tượng đề nghị chuyển cơ quan điều tra
  {
    path: `${ROUTES.BAO_CAO_CHI_TIET_CAC_VU_VIEC_DOI_TUONG_DE_NGHI_CHUYEN_CQDT}`,
    componentName: 'bao-cao-thong-ke/bao-cao-chi-tiec-cac-vu-viec-doi-tuong-de-nghi-chuyen-cqdt/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKE_MOI]
  },

  // Báo cáo kết quả xử lý cán bộ, công chức, viên chức theo kết luận thanh tra và kiến nghị KTNN
  {
    path: `${ROUTES.BAO_CAO_KET_QUA_XU_LY_CAN_BO_THEO_KLTT_VA_KIEN_NGHI_KTNN}`,
    componentName: 'bao-cao-thong-ke/bao-cao-ket-qua-xu-ly-can-bo-theo-kltt-va-kien-nghi-ktnn/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },

  // Báo cáo các kiến nghị đã hoàn thành theo các kết luận thanh tra, kiến nghị của KTNN
  {
    path: `${ROUTES.BAO_CAO_CAC_KIEN_NGHI_DA_HOAN_THANH_THEO_CAC_KLTT_KIEN_NGHI_CUA_KTNN}`,
    componentName: 'bao-cao-thong-ke/bao-cao-cac-kien-nghi-da-hoan-thanh-theo-cac-kltt-kien-nghi-cua-ktnn/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },

  // Báo cáo các kiến nghị chưa hoàn thành xong theo các kết luận thanh tra, kiến nghị của KTNN
  {
    path: `${ROUTES.BAO_CAO_CAC_KIEN_NGHI_CHUA_HOAN_THANH_XONG_THEO_CAC_KLTT_KIEN_NGHI_CUA_KTNN}`,
    componentName: 'bao-cao-thong-ke/bao-cao-cac-kien-nghi-chua-hoan-thanh-xong-theo-cac-kltt-kien-nghi-kttn/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS?.BAOCAOTHONGKE]
  },

  // BC tổng hợp kết quả thực hiện kết luận thanh tra
  {
    path: `${ROUTES.BAO_CAO_TONG_HOP_KET_LUAN_THANH_TRA}`,
    componentName: 'bao-cao-thong-ke/bao-cao-tong-hop-ket-luan-thanh-tra/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },

  //Tổng hợp kết quả thực hiện kết luận, quyết định xử phạt qua thanh tra chuyên ngành
  {
    path: `${ROUTES.BAO_CAO_TONG_HOP_THUC_HIEN_KET_LUAN_QUYET_DINH_XU_PHAT_QUA_THANH_TRA_CHUYEN_NGANH}`,
    componentName:
      'bao-cao-thong-ke/bao-cao-tong-hop-thuc-hien-ket-quyet-dinh-xu-phat-qua-thanh-tra-chuyen-nganh/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  //Tổng hợp kết quả thực hiện kết luận thanh tra hành chính (02/TTr)
  {
    path: `${ROUTES.BAO_CAO_TONG_HOP_THUC_HIEN_KET_LUAN_THANH_TRA_HANH_CHINH_02}`,
    componentName: 'bao-cao-thong-ke/bao-cao-tong-hop-thuc-hien-ket-luan-thanh-tra-hanh-chinh-02/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  // BC Tổng hợp kết quả thanh tra hành chính trong lĩnh vực tài chính ngân sách
  {
    path: `${ROUTES.BAO_CAO_TONG_HOP_KET_QUA_HANH_CHINH_TRONG_LINH_VUC_TCNS}`,
    componentName: 'bao-cao-thong-ke/bao-cao-tong-hop-ket-qua-thanh-tra-chinh-trong-linh-vuc-tcns/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },

  // Báo cáo chi tiết kết quả thực hiện kết luận thanh tra theo đơn vị
  {
    path: `${ROUTES.BAO_CAO_CHI_TIET_KET_QUA_THUC_HIEN_KLTT}`,
    componentName: 'bao-cao-thong-ke/bao-cao-chi-tiet-ket-qua-thuc-hien-KLTT/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },

  // Tổng hợp kết quả thực hiện kiến nghị
  {
    path: `${ROUTES.BAO_CAO_TONG_HOP_KET_QUA_THUC_HIEN_KIEN_NGHI}`,
    componentName: 'bao-cao-thong-ke/bao-cao-tong-hop-ket-qua-thuc-hien-kien-nghi/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },

  // Tổng hợp kết quả thực hiện kiến nghị
  {
    path: `${ROUTES.BAO_CAO_TONG_HOP_CAC_KIEN_NGHI_VE_CO_CHE_CHINH_SACH_DA_THUC_HIEN}`,
    componentName: 'bao-cao-thong-ke/bao-cao-tong-hop-cac-kien-nghi-ve-co-che-chinh-sach-da-thuc-hien/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },

  // Tổng hợp kết quả thanh tra hành chính
  {
    path: `${ROUTES.TONG_HOP_KET_QUA_THANH_TRA_HANH_CHINH}`,
    componentName: 'bao-cao-thong-ke/tong-hop-ket-qua-thanh-tra-hanh-chinh/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },

  // Tổng hợp kết quả thanh tra hành chính trong lĩnh vực xây dựng cơ bản
  {
    path: `${ROUTES.TONG_HOP_KET_QUA_THANH_TRA_HANH_CHINH_TRONG_LINH_VUC_XDCB}`,
    componentName: 'bao-cao-thong-ke/tong-hop-ket-qua-thanh-tra-hanh-chinh-trong-linh-vuc-dau-tu-xdcb/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },

  // Tổng hợp kết quả thanh tra hành chính trong lĩnh vực đất đai
  {
    path: `${ROUTES.TONG_HOP_KET_QUA_THANH_TRA_HANH_CHINH_TRONG_LINH_VUC_DAT_DAI}`,
    componentName: 'bao-cao-thong-ke/tong-hop-ket-qua-thanh-tra-hanh-chinh-trong-linh-vuc-dat-dai/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },

  // Tổng hợp kết quả thanh tra kiểm tra chuyên ngành
  {
    path: `${ROUTES.TONG_HOP_KET_QUA_THANH_TRA_KIEM_TRA_CHUYEN_NGANH}`,
    componentName: 'bao-cao-thong-ke/tong-hop-ket-qua-thanh-tra-kiem-tra-chuyen-nganh/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  // Tổng hợp kết quả kiến nghị chấn chỉnh
  {
    path: `${ROUTES.BAO_CAO_TONG_HOP_KIEN_NGHI_CHAN_CHINH_RUT_KINH_NGHIEM}`,
    componentName: 'bao-cao-thong-ke/tong-hop-kien-nghi-chan-chinh-rut-kinh-nghiem/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  // Tổng hợp kết quả kiến nghị trách nhiệm bản thân
  {
    path: `${ROUTES.BAO_CAO_TONG_HOP_KIEN_NGHI_KIEM_DIEM_TRACH_NHIEM_TAP_THE_CA_NHAN}`,
    componentName: 'bao-cao-thong-ke/tong-hop-kien-nghi-kiem-diem-trach-nhiem-ttcn/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  // Tổng hợp các kết quả kiểm điểm trách nhiệm cán bộ, công chức, viên chức theo các kết luận thanh tra
  {
    path: `${ROUTES.BAO_CAO_TONG_HOP_KIEN_NGHI_KIEM_DIEM_TRACH_NHIEM_CAN_BO_CONG_CHUC_VIEN_CHUC}`,
    componentName: 'bao-cao-thong-ke/tong-hop-kien-nghi-kiem-diem-trach-nhiem-can-bo-cong-chuc-vien-chuc/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  // Tổng hợp các kết quả thực hiện kiến nghị tài chính
  {
    path: `${ROUTES.BAO_CAO_TONG_HOP_KET_QUA_THUC_HIEN_KN_TAI_CHINH}`,
    componentName: 'bao-cao-thong-ke/tong-hop-ket-qua-thuc-hien-KN-tai-chinh/index',
    privateRouter: false,
    isMenu: true,
    permissions: []
  },
  // Báo cáo động
  {
    path: `${ROUTES.BAO_CAO_THONG_KE_DONG}`,
    componentName: 'bao-cao-thong-ke/bao-cao-dong/danh-sach/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKEDONG]
  },

  // Báo cáo động chi tiết
  {
    path: `${ROUTES.BAO_CAO_THONG_KE_DONG}/detail/:id`,
    componentName: 'bao-cao-thong-ke/bao-cao-dong/detail/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKEDONG]
  },

  // Báo cáo động thêm mới
  {
    path: `${ROUTES.BAO_CAO_THONG_KE_DONG}/create`,
    componentName: 'bao-cao-thong-ke/bao-cao-dong/create/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKEDONG]
  },

  // Báo cáo động chỉnh sửa
  {
    path: `${ROUTES.BAO_CAO_THONG_KE_DONG}/:id`,
    componentName: 'bao-cao-thong-ke/bao-cao-dong/create/index',
    privateRouter: false,
    isMenu: true,
    permissions: [PERMISSIONS.BAOCAOTHONGKEDONG]
  },

  // Theo dõi kiến nghị kiểm toán nhà nước
  {
    path: `${ROUTES.QL_DANH_SACH_KIEN_NGHI_KIEM_TOAN}`,
    componentName: 'kien-nghi-kiem-toan/danh-sach-kien-nghi/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KIENNGHIKIEMTOAN_XEMTATCA]
  },

  // Chi tiết theo dõi kiến nghị xử lý tài chính
  {
    path: `${ROUTES.QL_DANH_SACH_KIEN_NGHI_KIEM_TOAN}${ROUTES.CHI_TIET}${ROUTES.XU_LY_TAI_CHINH}${ROUTES.ID}`,
    componentName: 'kien-nghi-kiem-toan/chi-tiet-kien-nghi/xu-ly-kien-nghi-tai-chinh/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KIENNGHIKIEMTOAN_XEMTATCA]
  },

  // Chi tiết theo dõi kiến nghị xử lý cơ chế chính sách
  {
    path: `${ROUTES.QL_DANH_SACH_KIEN_NGHI_KIEM_TOAN}${ROUTES.CHI_TIET}${ROUTES.XU_LY_CO_CHE_CHINH_SACH}${ROUTES.ID}`,
    componentName: 'kien-nghi-kiem-toan/chi-tiet-kien-nghi/xu-ly-co-che-chinh-sach/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KIENNGHIKIEMTOAN_XEMTATCA]
  },

  // Chi tiết theo dõi kiến nghị xử lý kiểm điểm
  {
    path: `${ROUTES.QL_DANH_SACH_KIEN_NGHI_KIEM_TOAN}${ROUTES.CHI_TIET}${ROUTES.XU_LY_KIEM_DIEM_TRACH_NHIEM}${ROUTES.ID}`,
    componentName: 'kien-nghi-kiem-toan/chi-tiet-kien-nghi/xu-ly-kiem-diem-trach-nhiem/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KIENNGHIKIEMTOAN_XEMTATCA]
  },

  // Chi tiết theo dõi kiến nghị xử lý kiểm điểm
  {
    path: `${ROUTES.QL_DANH_SACH_KIEN_NGHI_KIEM_TOAN}${ROUTES.CHI_TIET}${`/xu-ly-chan-chinh-rut-kinh-nghiem`}${ROUTES.ID}`,
    componentName: 'kien-nghi-kiem-toan/chi-tiet-kien-nghi/xu-ly-chan-chinh-rut-kinh-nghiem/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KIENNGHIKIEMTOAN_XEMTATCA]
  },

  // Chi tiết theo dõi kiến nghị xử lý khác
  {
    path: `${ROUTES.QL_DANH_SACH_KIEN_NGHI_KIEM_TOAN}${ROUTES.CHI_TIET}${ROUTES.XU_LY_KHAC}${ROUTES.ID}`,
    componentName: 'kien-nghi-kiem-toan/chi-tiet-kien-nghi/xu-ly-khac/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KIENNGHIKIEMTOAN_XEMTATCA]
  },
  // ===== Phase 2: vụ án hình sự, báo cáo thu hồi, phúc tra KTNN, file tập trung, danh mục mới =====
  {
    path: ROUTES.VU_AN_KHOI_TO,
    componentName: 'vu-an/khoi-to/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.VUAN_KHOITO_CAPNHAT]
  },
  {
    path: ROUTES.VU_AN_TRUY_TO,
    componentName: 'vu-an/truy-to/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.VUAN_TRUYTO_CAPNHAT]
  },
  {
    path: ROUTES.VU_AN_SO_THAM,
    componentName: 'vu-an/so-tham/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.VUAN_XETXU_CAPNHAT]
  },
  {
    path: ROUTES.VU_AN_PHUC_THAM,
    componentName: 'vu-an/phuc-tham/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.VUAN_XETXU_CAPNHAT]
  },
  {
    path: ROUTES.VU_AN_THI_HANH_AN,
    componentName: 'vu-an/thi-hanh-an/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.VUAN_THIHANHAN_CAPNHAT]
  },
  {
    path: ROUTES.VU_AN_TIEN_DO_THU_HOI,
    componentName: 'vu-an/tien-do-thu-hoi/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.VUAN_THEODOI_CAPNHAT]
  },
  {
    path: ROUTES.VU_AN_UY_THAC,
    componentName: 'vu-an/uy-thac/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.VUAN_UYTHAC_CAPNHAT]
  },
  {
    path: ROUTES.VU_AN_THEO_DOI_CHUNG,
    componentName: 'vu-an/theo-doi-chung/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.VUAN]
  },
  {
    path: `${ROUTES.VU_AN_CHI_TIET}/:id`,
    componentName: 'vu-an/chi-tiet/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.VUAN]
  },
  {
    path: ROUTES.VU_AN_BAO_CAO_TONG_QUAN,
    componentName: 'vu-an/bao-cao/tong-quan',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.VUAN_BAOCAO]
  },
  {
    path: ROUTES.VU_AN_BAO_CAO_CHI_TIET,
    componentName: 'vu-an/bao-cao/chi-tiet',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.VUAN_BAOCAO]
  },
  {
    path: ROUTES.KTNN_PHUC_TRA,
    componentName: 'ktnn-phuc-tra/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KTNN_PHUCTRA]
  },
  {
    path: `${ROUTES.KTNN_PHUC_TRA}/:id`,
    componentName: 'ktnn-phuc-tra/chi-tiet',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.KTNN_PHUCTRA]
  },
  {
    path: ROUTES.QUAN_LY_FILE_TAP_TRUNG,
    componentName: 'quan-ly-file-tap-trung/index',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.QLFILE_TAPTRUNG]
  },
  {
    path: ROUTES.DANH_MUC_TOI_PHAM,
    componentName: 'system-management/danh-muc-phase2/toi-pham',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.DANHMUC, PERMISSIONS.DM_TOIPHAM_DANHSACH]
  },
  {
    path: ROUTES.DANH_MUC_LOAI_THU_HOI,
    componentName: 'system-management/danh-muc-phase2/loai-thu-hoi',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.DANHMUC, PERMISSIONS.DM_LOAITHUHOI_DANHSACH]
  },
  {
    path: ROUTES.DANH_MUC_LOAI_TAI_SAN,
    componentName: 'system-management/danh-muc-phase2/loai-tai-san',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.DANHMUC, PERMISSIONS.DM_LOAITAISAN_DANHSACH]
  },
  {
    path: ROUTES.DANH_MUC_FILE,
    componentName: 'system-management/danh-muc-phase2/loai-file',
    privateRouter: true,
    isMenu: true,
    permissions: [PERMISSIONS.DANHMUC, PERMISSIONS.DM_LOAIFILE_DANHSACH]
  },
  // 403 Forbidden
  {
    path: `${ROUTES.FORBIDDEN_ERROR}`,
    componentName: 'forbidden-error/index',
    privateRouter: true,
    isMenu: true,
    permissions: []
  },
  // The NotFoundPage is a catch-all and nothing should be below it.
  {
    path: '*',
    componentName: 'not-found/index',
    status: 404,
    privateRouter: false,
    isMenu: false,
    permissions: []
  }
]
